export const handleSkippingEndCard = (nextAction, cards, onGoToNextCard) => dispatch => {
    if (nextAction) {
        setTimeout(() => {
            const nextCard = cards[nextAction.order - 1];
            onGoToNextCard(
                nextAction.identifier,
                nextCard.type,
                nextAction.type,
                nextAction.skipFrontCard || nextAction.scrollableDesign
            );
        }, 100);
    }
};
